import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { ServerService } from '../../../service/server/server.service';
import { Params, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { InvoiceBuyDetaileComponent } from '../../../wharehouse-invoice-buy/invoice-buy-detaile/invoice-buy-detaile.component';
import { UserVideoComponent } from '../../../user/user-video/user-video.component';
import { WharehouseExit2Component } from '../../../wharehouse-reception/wharehouse-exit2/wharehouse-exit2.component';
import { MessageService } from '../../../service/message/message.service';
import { RecieveDetaileComponent } from '../../finance-recieve/recieve-detaile/recieve-detaile.component';
import { PayDetaileComponent } from '../../finance-pay/pay-detaile/pay-detaile.component';
import { InvoiceSaleDetaileComponent } from '../../../wharehouse-invoice-sale/invoice-sale-detaile/invoice-sale-detaile.component';

@Component({
  selector: 'app-financial2-list',
  templateUrl: './financial2-list.component.html',
  styleUrls: ['./financial2-list.component.scss']
})
export class Financial2ListComponent implements OnInit, OnDestroy {
  //**********************************************************
  public server: string = this.serverService.get_server();
  public server_main: string = this.serverService.get_server_main();
  public site: string = this.serverService.get_site();
  public no_record: string = this.serverService.no_record();
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public dir: any = JSON.parse(<any>localStorage.getItem('dir'));
  public lang_text: any = [];
  public user_id: number;
  public loading = false;
  public subscription: Subscription;
  public task_type: number | undefined;
  public confirm_delete: boolean | undefined;
  public count_total: number = 1;
  public page_number_first: number | undefined; public page_number_second: number | undefined; public page: number = 1;
  public code: any;
  public remain_temp: number = 0;
  public remain_temp2: number = 0;
  public list_remain: any = [];
  public show_excel: boolean = false;
  public excel: number = 1;
  public export_code: string | undefined;
  public type_task: number | undefined;
  public type: number | undefined;
  public search_all: string | undefined;
  public hidden: boolean = true;
  public comment: string;
  public user_title!: string;
  //******************************************************************************
  public list_record: any = [];
  public list_status: any = [];
  public list_ref: any = [];
  public creator: number | undefined;
  public video: string | undefined;
  public user_cost: number | undefined;
  public path_export: string | undefined;
  //******************************************************************************
  public id: number | undefined;
  public pre_status: boolean | undefined; public next_status: boolean | undefined; public new_status: boolean | undefined;
  public status_id: number | undefined; public status_id_search: number | undefined;
  public title: string | undefined; public title_search: string | undefined;
  public search_array: any = [];
  //************
  public selected_record: any = [];
  public select_all: boolean | undefined;
  public indeterminate: boolean = false;
  public checked: boolean = false;
  public access_service: number | undefined;
  public level: number | undefined;
  //***********
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  public dataSource: any | undefined;
  public displayedColumns = ['row', 'date', 'comment', 'document', 'bed', 'best', 'remain'];
  //*************
  public form1_group: FormGroup | any;
  public form1_search_group: FormGroup | any;
  public sum: number = 0;
  public best: number = 0;
  public bed: number = 0;
  public remain: number = 0;
  public remain2: number = 0;
  public user: number;
  public cost: number | undefined;
  public date1: string;
  public date2: string;
  public ref: number | undefined
  public bank: number | undefined;
  public account: number | undefined;
  public asc_desc: string = 'asc';
  public order: string;
  public query_order: string;
  public ref_search_all!: number;
  public ref_link!: string;
  public ref_service!: number;
  public ref_i!: number;
  public ref_page!: number;
  public ref_count_total!: string;
  public ref_order!: string;


  //************** */
  constructor(
    public serverService: ServerService,
    public router: Router
    , public activatedRoute: ActivatedRoute
    , public matSnackBar: MatSnackBar
    , public dialog: MatDialog
    , public dialogRef: MatDialog
    , public messageService: MessageService
    , public sheet: MatBottomSheet) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.code = params['id'];
      }
    )
    this.serverService.status1(2);
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.activatedRoute.queryParams.subscribe(
      (params) => {
        this.user = params['user'];
        this.cost = params['cost'];
        this.user_cost = params['user_cost'];
        this.date1 = params['date1'];
        this.date2 = params['date2'];
        this.query_order = params['order'];
        this.bank = params['bank'];
        this.account = params['account'];
        this.ref_link = params['link'];
        this.ref_service = params['service'];
        this.ref_search_all = params['search_all'];
        this.ref_i = params['i'];
        this.ref_order = params['order'];
        this.ref_page = params['page'];
        this.ref_count_total = params['count_total'];
        this.check_access(4, 1, 0, 1, 1);
      }
    );
    //**************
  }//end ngOnInit
  get_user_title() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 7148, id: this.user }).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.user_title = res['result'][0].user_title;
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  back_to_bill() {
    this.router.navigate(['/home', this.ref_link, this.ref_service],
      {
        queryParams: {
          back_i: this.ref_i,
          back_page: this.ref_page,
          search_all: this.ref_search_all,
          back_order: this.ref_order,
          count_total: this.ref_count_total,
        }
      })
  }
  set_hidden() {
    this.hidden = true;
    this.user = 1;
  }

  order_ref(id: number, ref: any, financial_document: number) {
    if (ref == 1) {
      if (financial_document == 6) {
        this.dialog.open(RecieveDetaileComponent, {
          width: '85rem',
          height: 'auto',
          disableClose: true,
          data: { type_task: 2, id: id, readonly: true, code: this.code }
        });
      }
      else if (financial_document == 7) {
        this.dialog.open(PayDetaileComponent, {
          width: '85rem',
          height: 'auto',
          disableClose: true,
          data: { type_task: 2, id: id, readonly: true, code: this.code }
        });
      }
    }
    if (ref == 'invoice_sale') {
      const dialogRef = this.dialog.open(InvoiceSaleDetaileComponent, {
        width: '85rem',
        height: 'auto',
        disableClose: true,
        data: { type_task: 2, id: id, readonly: true, code: this.code }
      });
    }
    if (ref == 'invoice_buy') {
      const dialogRef = this.dialog.open(InvoiceBuyDetaileComponent, {
        width: '85rem',
        height: 'auto',
        disableClose: true,
        data: { type_task: 2, id: id, readonly: true, code: this.code }
      });
    }
    if (ref == 3) {
      this.dialog.open(WharehouseExit2Component, {
        'width': '85rem',
        'height': 'auto',
        data: { 'reception_id': id, ref: 'exit', type: 2, code: this.code, creator: this.creator, readonly: true }
      });
    }
  }

  //****************************************************************************
  check_access(type_task: any, page: number, id: any, excel: number, loading: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, type: 'user', user_id: this.user_id, id: this.code }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.access_service = res['result'][0].count;
          this.path_export = res['path_export'];
          this.check_access2(type_task, page, id, excel, loading, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  check_access2(type_task: any, page: number, id: any, excel: number, loading: number, access_service: number): any {
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', { 'address': 6, user_id: this.creator, id: this.code }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          this.title = res['result'][0].title;
          this.video = res['result'][0].video;
          this.loading = false;
          if (type_task == 3) {
          }
          if (type_task == 4) {
            if (this.user > 0) {
              this.get_user_title();
            }
            this.load_data(page, excel, loading, -1);
          }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  open_comment(comment: string) {
    this.comment = comment;
  }
  load_data2(id: number) {
    this.page = 1;
    this.ref = id;
    this.load_data(1, 1, 1, -1);
  }
  sort(sort: string, asc_desc: string) {
    if (asc_desc == 'asc') this.asc_desc = 'desc';
    else this.asc_desc = 'asc';
    this.order = sort + " " + this.asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  reset_sort(sort: string, asc_desc: string) {
    this.order = sort + " " + asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  load_data(page: number, excel: number, loading: number, changedRows: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    if (page == 1) { this.page = 1; }
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    if (page == 5) { this.page = 1; }
    //6275 - 6237 - 6296
    //6296
    var address = 6914;
    var obj = {
      'address': address
      , "page": this.page
      , 'type': this.type
      , 'lang': this.lang
      , 'excel': excel
      , 'user_id': this.user_id
      , 'search': this.search_array
      , 'ref': this.ref
      , 'search_all': this.search_all
      , 'changedRows': changedRows
      , 'user': this.user
      , 'cost': this.cost
      , 'date1': this.date1
      , 'date2': this.date2
      , 'account': this.account
      , 'bank': this.bank
      , 'code': this.code
      , 'query_order': this.query_order
      , 'order': this.order
      , 'creator': this.creator
      , 'user_cost': this.user_cost
      , 'path_export': this.path_export
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (excel == 1) {
            if (changedRows == -1) this.list_record = [];
            if (changedRows > 0 || changedRows == -1) {
              for (var i = 0; i < res['num']; i++) {
                if (i == 0 && page == 1) {
                  res['result'][i].remain2 = res['remain'];
                  this.remain_temp = res['remain'];
                }
                else if (i == 0 && page == 2) {
                  res['result'][i].remain2 = this.remain_temp;
                }
                else if (i == 0 && page == 3) {
                  res['result'][i].remain2 = this.list_remain[this.page];
                  this.list_remain.splice(this.list_remain.length - 1, 1);
                  if (this.page == 1) this.list_remain[1] = res['remain'];
                }
                else {
                  if (res['result'][i - 1].bed > 0) {
                    res['result'][i].remain2 = Number(res['result'][i - 1].remain2) - Number(res['result'][i - 1].bed);
                  }
                  else {
                    res['result'][i].remain2 = Number(res['result'][i - 1].remain2) + Number(res['result'][i - 1].best);
                  }
                }
                if (i == 19) {
                  this.remain_temp = res['result'][i].remain2;
                  if (res['result'][i].bed > 0) {
                    this.remain_temp = Number(this.remain_temp) - Number(res['result'][i].bed);
                  }
                  else {
                    this.remain_temp = Number(this.remain_temp) + Number(res['result'][i].best);
                  }
                }
                this.list_record.push(res['result'][i]);
              }//end for
            }
            if (page == 1) {
              this.list_remain.push(0);
              this.list_remain.push(res['remain']);
            }
            if (page == 2 && this.list_remain.length > 0) {
              this.list_remain.push(res['result'][0].remain2);
            }
            this.sum = res['sum'];
            this.best = res['best'];
            this.bed = res['bed'];
            this.remain = res['remain'];

            this.remain2 = res['remain2'];
            this.dataSource = new MatTableDataSource(this.list_record);
            this.count_total = res['count'];
            this.pages(0);
            this.serverService.change_window_resize(2, '', 0);
            this.serverService.send_services_id(this.code);
            this.serverService.send_reset({});
          }
          else if (excel == 2) {
            this.export_excel(res['export_code']);
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data
  export_excel(code: number) {
    if (code > 0) {
      var x = <any>document.getElementById("excel");
      x.href = this.site + "/export/" + code + ".xlsx";
      x.click();
    }
  }
  pages(count: number) {
    this.count_total = this.count_total + count;
    this.page_number_first = this.page * 20 - 19;
    this.page_number_second = this.page * 20;
    if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
    else { this.pre_status = false; this.new_status = true; }
    if (this.list_record.length < 20 || (this.page * 20 >= this.count_total)) {
      this.page_number_second = this.count_total;
      this.next_status = true;
    }//end if
    else { this.next_status = false; }
  }
  open_video() {
    this.dialog.open(UserVideoComponent, {
      width: '45rem',
      height: 'auto',
      data: { id: this.code }
    })
  }
  //***************************************************************************
  get_bg(id: number) {
    this.id = id;
  }
  //*******************************************************************************
  change_resize() {
    //this.serverService.change_window_resize(1,'',0);
  }//end change_resize

  //*******************************************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}

